<template>
  <div class="p-help-feedback">
    <template v-if="!showThankYou">
      <template v-if="!showForm">
        <p class="f-body-14 t-fg-primary">{{ $t('general.helpFeedback.question') }}</p>
        <div class="p-help-feedback__buttons">
          <p-link
            :label="String($t('general.yes'))"
            underline-color="primary"
            size="md"
            passive
            class="t-fg-primary cursor-pointer"
            @click="handleYesClick"
          />
          <p-link
            :label="String($t('general.no'))"
            underline-color="primary"
            size="md"
            passive
            class="t-fg-primary cursor-pointer"
            @click="handleNoClick"
          />
        </div>
      </template>

      <div v-else class="p-help-feedback__form">
        <div class="p-help-feedback__form-options">
          <label
            v-for="option in feedbackOptions"
            :key="option.id"
            class="p-help-feedback__checkbox"
          >
            <input v-model="selectedOptions" type="checkbox" :value="option.id" />
            <span class="f-utility-14 t-fg-primary">{{ option.label }}</span>
          </label>
        </div>

        <div class="p-help-feedback__textarea-container">
          <h3 class="f-title-20 t-fg-primary">{{ $t('general.helpFeedback.detailTitle') }}</h3>
          <textarea
            v-model="feedbackText"
            class="p-help-feedback__textarea"
            :placeholder="$t('general.helpFeedback.textareaPlaceholder')"
            rows="4"
          />
        </div>

        <p-button
          variant="filled"
          color="green"
          size="md"
          class="p-help-feedback__submit"
          @click="handleSubmit"
        >
          {{ $t('general.helpFeedback.submit') }}
        </p-button>
      </div>
    </template>

    <p v-else class="f-body-14 t-fg-primary">
      {{ $t('general.helpFeedback.thankYou') }}
    </p>
  </div>
</template>

<script setup lang="ts">
interface FeedbackOption {
  id: string
  label: string
}

const feedbackOptions: FeedbackOption[] = [
  { id: 'unclear', label: String($t('general.helpFeedback.options.unclear')) },
  { id: 'noAnswer', label: String($t('general.helpFeedback.options.noAnswer')) },
  { id: 'notWorking', label: String($t('general.helpFeedback.options.notWorking')) },
  { id: 'other', label: String($t('general.helpFeedback.options.other')) },
]

const showForm = ref(false)
const showThankYou = ref(false)
const selectedOptions = ref<string[]>([])
const feedbackText = ref('')

const handleYesClick = () => {
  showThankYou.value = true
  emit('on-feedback', true)
}

const handleNoClick = () => {
  showForm.value = true
  emit('on-feedback', false)
}

const handleSubmit = () => {
  emit('on-submit', {
    options: selectedOptions.value,
    text: feedbackText.value,
  })
  showForm.value = false
  showThankYou.value = true
}

const emit = defineEmits(['on-feedback', 'on-submit'])
</script>
